import {Role} from '../../enums/role.enum';

export class TokenContext {
  public id: number;
  public expirationDate: string;
  public role: Role;
}



// WEBPACK FOOTER //
// ./src/app/models/user/token-context.ts